// extracted by mini-css-extract-plugin
module.exports = {"double":"Double_double__27h1p","doubleContent":"Double_doubleContent__1MEYL"};